import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/user_login', component: () => import('@/views/login/user_login')},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'fa fa-home'}
    }]
  },
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    alwaysShow: true,
    meta: {title: '商品', icon: 'fa fa-shopping-basket'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
    {
      path: 'shelf',
      name: 'shelf',
      component: () => import('@/views/pms/product/shelf'),
      meta: {title: '商品上下架', noCache: true,  affix: true}
    },
    {
      path: 'examine',
      name: 'examine',
      component: () => import('@/views/pms/product/examine'),
      meta: {title: '商品资料维护', noCache: true,  affix: true}
    },
    {
      path: 'examineResult',
      name: 'examineResult',
      component: () => import('@/views/pms/product/examineResult'),
      meta: {title: '商品审核结果', noCache: true,  affix: true}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品' , noCache: true,  affix: true},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productCateList',
        name: 'productCateList',
        component: () => import('@/views/pms/productCate/productCateList'),
        meta: {title: '当前分类下商品'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性', noCache: true,  affix: true},
        hidden: true
      },
      {
        path: 'productLable',
        name: 'productLable',
        component: () => import('@/views/pms/productLable/index'),
        meta: {title: '商品标签', icon: 'product-cate'}
      },
      {
        path: 'uploadproductLable',
        name: 'uploadproductLable',
        component: () => import('@/views/pms/productLable/upload'),
        meta: {title: '导入商品数据'},
        hidden:true
      },
      {
        path: 'productLablelist',
        name: 'productLablelist',
        component: () => import('@/views/pms/productLable/productRelationList'),
        meta: {title: '标签商品列表', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'parameterSpu',
        name: 'parameterSpu',
        component: () => import('@/views/pms/parameter/spu/index'),
        meta: {title: '商品参数SPU', icon: 'product-attr'}
      },
      {
        path: 'addparameterSpu',
        name: 'addparameterSpu',
        component: () => import('@/views/pms/parameter/spu/add'),
        meta: {title: '添加SPU'},
        hidden:true
      },
      {
        path: 'updateparameterSpu',
        name: 'updateparameterSpu',
        component: () => import('@/views/pms/parameter/spu/update'),
        meta: {title: '编辑SPU'},
        hidden:true
      },
      {
        path: 'uploadparameterSpu',
        name: 'uploadparameterSpu',
        component: () => import('@/views/pms/parameter/spu/upload'),
        meta: {title: '导入SPU'},
        hidden:true
      },
      {
        path: 'parameterSku',
        name: 'parameterSku',
        component: () => import('@/views/pms/parameter/sku/index'),
        meta: {title: '商品参数SKU', icon: 'product-attr'}
      },
      {
        path: 'addparameterSku',
        name: 'addparameterSku',
        component: () => import('@/views/pms/parameter/sku/add'),
        meta: {title: '添加SKU'},
        hidden:true
      },
      {
        path: 'updateparameterSku',
        name: 'updateparameterSku',
        component: () => import('@/views/pms/parameter/sku/update'),
        meta: {title: '编辑SKU'},
        hidden:true
      },
      {
        path: 'ImageDetail',
        name: 'ImageDetail',
        component: () => import('@/views/pms/parameter/sku/ImageDetail'),
        meta: {title: '添加商品图片'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },
      {
        path: 'platform',
        name: 'platform',
        component: () => import('@/views/pms/platform/index'),
        meta: {title: '平台对接'}
      },
      {
        path: 'manufactor',
        name: 'manufactor',
        component: () => import('@/views/pms/company/index'),
        meta: {title: '厂家管理'}
      },
      {
        path: 'companyCertificate',
        name: 'companyCertificate',
        component: () => import('@/views/pms/company/certificate'),
        meta: {title: '厂家资质', noCache: true,  affix: true}
      },
      {
        path: 'health',
        name: 'health',
        component: () => import('@/views/pms/health/index'),
        meta: {title: '保健品建档'}
      },
      {
        path: 'healthCertificate',
        name: 'healthCertificate',
        component: () => import('@/views/pms/health/certificate'),
        meta: {title: '保健品资质', noCache: true,  affix: true}
      },
      {
        path: 'examineCertificate',
        name: 'examineCertificate',
        component: () => import('@/views/pms/health/examineCertificate'),
        meta: {title: '资质审核', noCache: true,  affix: true}
      },
      {
        path: 'healthexamine',
        name: 'healthexamine',
        component: () => import('@/views/pms/health/examine'),
        meta: {title: '建档审核'}
      },
      {
        path: 'stockAlert',
        name: 'stockAlert',
        component: () => import('@/views/pms/stockAlert/index'),
        meta: {title: '库存预警'}
      },
      {
        path: 'stockLock',
        name: 'stockLock',
        component: () => import('@/views/pms/stockLock/index'),
        meta: {title: '库存分配'}
      },
      {
        path: 'allocationInventory',
        name: 'allocationInventory',
        component: () => import('@/views/pms/stockLock/allocationInventory'),
        meta: {title: '分配库存'}
      },
      {
        path: 'supplierBusiness',
        name: 'supplierBusiness',
        component: () => import('@/views/pms/supplierBusiness/index'),
        meta: {title: '货主业务类型'}
      },
      {
        path: 'adjustGoodsPrice',
        name: 'adjustGoodsPrice',
        component: () => import('@/views/pms/product/adjustGoodsPrice'),
        meta: {title: '商品调价'}
      },
      {
        path: 'notImgGoods',
        name: 'notImgGoods',
        component: () => import('@/views/pms/product/notImgGoods'),
        meta: {title: '无图片商品'},
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    alwaysShow: true,
    meta: {title: '订单', icon: 'fa fa-first-order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '全部订单'}
      },
      {
        path: 'nopayorder',
        name: 'nopayorder',
        component: () => import('@/views/oms/order/nopayorder'),
        meta: {title: '待支付订单'}
      },
      {
        path: 'deliverorder',
        name: 'deliverorder',
        component: () => import('@/views/oms/order/deliverorder'),
        meta: {title: '待发货订单'}
      },
      {
        path: 'collectorder',
        name: 'collectorder',
        component: () => import('@/views/oms/order/collectorder'),
        meta: {title: '待收货订单'}
      },
      {
        path: 'outOfStockOrdes',
        name: 'outOfStockOrdes',
        component: () => import('@/views/oms/apply/OutOfStockOrdes'),
        meta: {title: '查看缺货订单'},
        hidden:true
      },
      {
        path: 'returnorder',
        name: 'returnorder',
        component: () => import('@/views/oms/order/returnorder'),
        meta: {title: '售后订单', noCache: true,  affix: true}
      },
      {
        path: 'service_audit',
        name: 'service_audit',
        component: () => import('@/views/oms/order/returnorder1'),
        meta: {title: '客服审核订单', noCache: true,  affix: true}
      },
      {
        path: 'Warehouse',
        name: 'Warehouse',
        component: () => import('@/views/oms/order/Warehouse'),
        meta: {title: '仓库管理订单'}
      },
      {
        path: 'warehouse_audit',
        name: 'warehouse_audit',
        component: () => import('@/views/oms/order/returnorder2'),
        meta: {title: '仓库审核订单', noCache: true,  affix: true}
      },
      {
        path: 'cancelorder',
        name: 'cancelorder',
        component: () => import('@/views/oms/order/cancelorder'),
        meta: {title: '仓库审核已取消订单'}
      },
      {
        path: 'changeprice',
        name: 'changeprice',
        component: () => import('@/views/oms/changeprice/index'),
        meta: {title: '财务审核改价订单', noCache: true,  affix: true}
      },
      {
        path: 'finance_audit',
        name: 'finance_audit',
        component: () => import('@/views/oms/order/returnorder3'),
        meta: {title: '财务审核订单', noCache: true,  affix: true}
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('@/views/oms/invoice/index'),
        meta: {title: '财务审核发票', noCache: true,  affix: true}
      },
      {
        path: 'FinancialAuditCancelOrder',
        name: 'FinancialAuditCancelOrder',
        component: () => import('@/views/oms/order/cancelorder2'),
        meta: {title: '财务审核已取消订单'}
      },
      {
        path: 'businessOrder',
        name: 'businessOrder',
        component: () => import('@/views/oms/order/businessOrder'),
        meta: {title: '供应商订单列表'},
        hidden:true
      },
      {
        path: 'businessOrderDetail',
        name: 'businessOrderDetail',
        component: () => import('@/views/oms/order/businessOrderDetail'),
        meta: {title: '供应商订单详情', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'businessStockOrder',
        name: 'businessStockOrder',
        component: () => import('@/views/oms/order/businessStockOrder'),
        meta: {title: '供应商备货订单列表'},
        hidden:true
      },
      {
        path: 'businessStockDetail',
        name: 'businessStockDetail',
        component: () => import('@/views/oms/order/businessStockDetail'),
        meta: {title: '供应商备货订单详情', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情',noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'cancelOrdersByOrderDetail',
        name: 'cancelOrdersByOrderDetail',
        component: () => import('@/views/oms/order/cancelOrdersByOrderDetail'),
        meta: {title: '取消商品明细'},
        hidden:true
      },

      {
        path: 'bill_of_parcels_Details',
        name: 'bill_of_parcels_Details',
        component: () => import('@/views/oms/order/bill_of_parcels_Details'),
        meta: {title: '出库单'},
        hidden:true
      },
      // {
      //   path: 'returnApply',
      //   name: 'returnApply',
      //   component: () => import('@/views/oms/apply/index'),
      //   meta: {title: '退货申请处理', icon: 'order-return'}
      // },
      // {
      //   path: 'returnReason',
      //   name: 'returnReason',
      //   component: () => import('@/views/oms/apply/reason'),
      //   meta: {title: '退货原因设置', icon: 'order-return-reason'}
      // },

      {
        path: 'examineTransfer',
        name: 'examineTransfer',
        component: () => import('@/views/oms/apply/examineTransfer'),
        meta: {title: '财务审核转账'}
      },
      {
        path: 'offlineBillingAudit',
        name: 'offlineBillingAudit',
        component: () => import('@/views/oms/apply/offlineBillingAudit'),
        meta: {title: '挂账审核'}
      },

      //offlineBillingAudit
      {
        path: 'outOfStockOrde',
        name: 'outOfStockOrde',
        component: () => import('@/views/oms/apply/outOfStockOrde'),
        meta: {title: '缺货订单审核'},
        hidden:true
      },
      {
        path: 'orderPick',
        name: 'orderPick',
        component: () => import('@/views/oms/order/orderPick'),
        meta: {title: '待拣货订单2'}
      },
      {
        path: 'paySupOrder',
        name: 'paySupOrder',
        component: () => import('@/views/oms/order/paySupOrder'),
        meta: {title: '科欣上账确认'}
      }
    ]
  },
  {
    path:'/user',
    component: Layout,
    redirect: '/user/userlist',
    name: 'user',
    alwaysShow: true,
    meta: {title: '用户', icon: 'fa fa-user-o'},
    children: [
      {
        path: 'userlist',
        name: 'userlist',
        component: () => import('@/views/user/user/index'),
        meta: {title: '上游用户'}
      },
      {
        path: 'userlist2',
        name: 'userlist2',
        component: () => import('@/views/user/user/index2'),
        meta: {title: '下游用户'}
      },
      // {
      //   path: 'salesMan',
      //   name: 'salesMan',
      //   component: () => import('@/views/salesman/index'),
      //   meta: {title: '业务员列表'}
      // },
      {
        path: 'nocompanyuser',
        name: 'nocompanyuser',
        component: () => import('@/views/user/user/user'),
        meta: {title: '无单位会员', noCache: true,  affix: true}
      },
      {
        path: 'searchUser',
        name: 'searchUser',
        component: () => import('@/views/user/user/searchUser'),
        meta: {title: '会员列表', noCache: true,  affix: true}
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '管理员用户管理', noCache: true,  affix: true}
      },
      {
        path: 'money',
        name: 'money',
        component: () => import('@/views/user/user/money'),
        meta: {title: '资金明细', noCache: true,  affix: true}
      },
      {
        path: 'examineMoney',
        name: 'examineMoney',
        component: () => import('@/views/user/user/examineMoney'),
        meta: {title: '资金审核', noCache: true,  affix: true}
      },
      {
        path: 'historyredbag',
        name: 'historyredbag',
        component: () => import('@/views/user/user/historyredbag'),
        meta: {title: '红包明细', noCache: true,  affix: true}
      },
      {
        path: 'company',
        name: 'company',
        component: () => import('@/views/user/company/index'),
        meta: {title: '往来单位'}
      },
      {
        path: 'curCompany',
        name: 'curCompany',
        component: () => import('@/views/user/company/curCompany'),
        meta: {title: '往来单位', noCache: true,  affix: true}
      },
      {
        path: 'address',
        name: 'address',
        component: () => import('@/views/user/address/index'),
        meta: {title: '收货地址', noCache: true,  affix: true}
      },
      {
        path: 'certificate',
        name: 'certificate',
        component: () => import('@/views/user/certificate/list'),
        meta: {title: '公司资质', noCache: true,  affix: true},
        hidden: true
      },
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/record/message/index'),
        meta: {title: '投诉建议'},
      },
      {
        path: 'customizePriceUser',
        name: 'customizePriceUser',
        component: () => import('@/views/user/user/customizePriceUser'),
        meta: {title: '自定价格用户'},
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/adposition',
    name: 'sms',
    alwaysShow: true,
    meta: {title: '营销', icon: 'fa fa-calendar-check-o'},
    children: [
      {
        path: 'adposition',
        name: 'adposition',
        component: () => import('@/views/sms/ad_position/index'),
        meta: {title: '广告管理'}
      },
      {
        path: 'advertiselist',
        name: 'advertiselist',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'activitys',
        name: 'activitys',
        component: () => import('@/views/sms/activitys/index'),
        meta: {title: '活动管理', noCache: true,  affix: true}
      },
      {
        path: 'UploadActivitysProdcut',
        name: 'UploadActivitysProdcut',
        component: () => import('@/views/sms/activitys/upload'),
        meta: {title: '导入活动商品'}
      },
      {
        path: 'event',
        name: 'event',
        component: () => import('@/views/sms/event/index'),
        meta: {title: '活动上报'}
      },
      {
        path: 'eventgoods',
        name: 'eventgoods',
        component: () => import('@/views/sms/event/eventgoods'),
        meta: {title: '活动商品', noCache: true,  affix: true}
      },
      {
        path: 'eventexamine',
        name: 'eventexamine',
        component: () => import('@/views/sms/event/examine'),
        meta: {title: '上报审核', noCache: true,  affix: true}
      },
      {
        path: 'Discount',
        name: 'Discount',
        component: () => import('@/views/sms/activitys/discount'),
        meta: {title: '优惠管理', noCache: true,  affix: true},
        hidden:true,
      },
      {
        path: 'ProductRelation',
        name: 'ProductRelation',
        component: () => import('@/views/sms/activitys/productRelationList'),
        meta: {title: '活动商品列表', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/activitys/coupon'),
        meta: {title: '优惠券列表', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'specialCoupon',
        name: 'specialCoupon',
        component: () => import('@/views/sms/activitys/specialCoupon'),
        meta: {title: '专品券', noCache: true,  affix: true},
        hidden:true
      },
      // {
      //   path: 'customerCoupon',
      //   name: 'customerCoupon',
      //   component: () => import('@/views/sms/activitys/customerCoupon'),
      //   meta: {title: '用户券', noCache: true,  affix: true},
      //   hidden:true
      // },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/activitys/history'),
        meta: {title: '优惠券领取详情', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'combination',
        name: 'combination',
        component: () => import('@/views/sms/combination/index'),
        meta: {title: '组合套餐'}
      },
      {
        path: 'combinationProduct',
        name: 'combinationProduct',
        component: () => import('@/views/sms/combination/productList'),
        meta: {title: '套餐商品', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'subject',
        name: 'subject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题列表'}
      },
      {
        path: 'subjectList',
        name: 'subjectList',
        component: () => import('@/views/sms/subject/subjectList'),
        meta: {title: '专题商品列表', noCache: true, affix: true},
        hidden:true
      },
      {
        path: 'uploadSubject',
        name: 'uploadSubject',
        component: () => import('@/views/sms/subject/upload'),
        meta: {title: '专题数据'},
        hidden:true
      },
      {
        path: 'project',
        name: 'homeProject',
        component: () => import('@/views/sms/project/index'),
        meta: {title: '专题模板'}
      },
      {
        path: 'addProject',
        name: 'addProject',
        component: () => import('@/views/sms/project/add'),
        meta: {title: '添加专题模板'},
        hidden:true
      },
      {
        path: 'updateProject',
        name: 'updateProject',
        component: () => import('@/views/sms/project/update'),
        meta: {title: '编辑专题模板'},
        hidden:true
      },
      {
        path: 'quehuo',
        name: 'quehuo',
        component: () => import('@/views/sms/quehuo/index'),
        meta: {title: '缺货列表'}
      },
      {
        path: 'highProfit',
        name: 'highProfit',
        component: () => import('@/views/sms/highProfit/index'),
        meta: {title: '高毛利商品'}
      },
      {
        path: 'otherCommission',
        name: 'otherCommission',
        component: () => import('@/views/sms/highProfit/otherCommission'),
        meta: {title: '其他提成', noCache: true,  affix: true}
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/sms/news/index'),
        meta: {title: '新闻类别'}
      },
      {
        path: 'newslist',
        name: 'newslist',
        component: () => import('@/views/sms/news/newslist'),
        meta: {title: '管理新闻'},
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/sms/news/footerlist'),
        meta: {title: '底部文章'},
      },
      {
        path: 'LuckList',
        name: 'LuckList',
        component: () => import('@/views/sms/luck/index'),
        meta: {title: '抽奖管理'},
        hidden:true
      },
      {
        path: 'luckDrawList',
        name: 'luckDrawList',
        component: () => import('@/views/sms/luck/peopleList'),
        meta: {title: '抽奖人设置', noCache: true,  affix: true},
        hidden:true
      },
      {
        path: 'redBag',
        name: 'redBag',
        component: () => import('@/views/sms/redBag/index'),
        meta: {title: '红包管理'},
        hidden:true
      },
      {
        path: 'redBagHistory',
        name: 'redBagHistory',
        component: () => import('@/views/sms/redBag/history'),
        meta: {title: '红包记录'},
        hidden:true
      },
      {
        path: 'couponList',
        name: 'couponList',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '红包记录'},
        hidden:true
      },
      // {
      //   path: 'updateNews',
      //   name: 'updateNews',
      //   component: () => import('@/views/sms/news/update'),
      //   meta: {title: '修改新闻'},
      //   hidden: true
      // },
    ]
  },
  {
    path: '/set',
    component: Layout,
    redirect: '/set/basics',
    name: 'set',
    alwaysShow: true,
    meta: {title: '设置', icon: 'fa fa-cogs'},
    children: [
      {
        path: 'SmallVersion',
        name: 'SmallVersion',
        component: () => import('@/views/set/SmallVersion/index'),
        meta: {title: '版本发布'}
      },
      {
        path: 'audit',
        name: 'audit',
        component: () => import('@/views/set/SmallVersion/audit'),
        meta: {title: '版本审核'}
      },
      {
        path: 'basics',
        name: 'basics',
        component: () => import('@/views/set/basics/index'),
        meta: {title: '基础数据'}
      },
      {
        path: 'control',
        name: 'control',
        component: () => import('@/views/set/control/index'),
        meta: {title: '控销设置', noCache: true,  affix: true}
      },
      {
        path: 'hotkewords',
        name: 'hotkewords',
        component: () => import('@/views/set/hotkewords/index'),
        meta: {title: '热门关键词'}
      },
      {
        path: 'distributionList',
        name: 'distributionList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '地区&配送'},
        // hidden:true
      },
      {
        path: 'code',
        name: 'code',
        component: () => import('@/views/set/code/index'),
        meta: {title: '往来单位对码'}
      },
      {
        path: 'supplierMatch',
        name: 'supplierMatch',
        component: () => import('@/views/set/supplier/index'),
        meta: {title: '供应商对码'}
      },
      {
        path: 'system',
        name: 'system',
        component: () => import('@/views/set/system/index'),
        meta: {title: '商店设置'},
      },
      {
        path: 'configure',
        name: 'configure',
        component: () => import('@/views/set/system/configure'),
        meta: {title: '基础配置'},
      },
      {
        path: 'OperationRecord',
        name: 'OperationRecord',
        component: () => import('@/views/set/record/index'),
        meta: {title: '操作记录'},
      },
      {
        path: 'goodsMatch',
        name: 'goodsMatch',
        component: () => import('@/views/set/goodsMatch/index'),
        meta: {title: '商品对码'}
      },
      {
        path: 'seoSet',
        name: 'seoSet',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: 'SEO设置'}
      },
      {
        path: 'addControl',
        name: 'addControl',
        component: () => import('@/views/set/control/add'),
        meta: {title: '添加控销'},
        hidden:true
      },
      {
        path: 'updateControl',
        name: 'updateControl',
        component: () => import('@/views/set/control/update'),
        meta: {title: '修改控销'},
        hidden: true
      },
      {
        path: 'viewsControlGoods',
        name: 'viewsControlGoods',
        component: () => import('@/views/set/control/goods'),
        meta: {title: '设置商品'},
        hidden: true
      },
      {
        path: 'Express',
        name: 'Express',
        component: () => import('@/views/oms/express/index'),
        meta: {title: '物流设置'}
      },
      {
        path: 'postage',
        name: 'postage',
        component: () => import('@/views/set/postage/index'),
        meta: {title: '运费设置'}
      },
      {
        path: 'tips',
        name: 'tips',
        component: () => import('@/views/set/tips/index'),
        meta: {title: '消息提示'}
      },
      {
        path: 'shelves',
        name: 'shelves',
        component: () => import('@/views/set/shelves/index'),
        meta: {title: '货架号列表'}
      },
      {
        path: 'sdetail/:name',
        name: 'sdetail',
        component: () => import('@/views/set/shelves/detail'),
        meta: {title: '货架号打印'}
      },
      {
        path: 'kefu',
        name: 'kefu',
        component: () => import('@/views/set/kefu/kefuManage'),
        meta: {title: '客服管理'}
      },
      {
        path: 'receptionist',
        name: 'receptionist',
        component: () => import('@/views/set/kefu/receptionist'),
        meta: {title: '接待员管理'}
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/views/set/calendar/index'),
        meta: {title: '日程管理'}
      },
      {
        path: 'logisticsBlacklist',
        name: 'logisticsBlacklist',
        component: () => import('@/views/set/logisticsBlacklist/index'),
        meta: {title: '物流黑名单'}
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    alwaysShow: true,
    meta: {title: '权限', icon: 'fa fa-lock'},
    children: [
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu', keepAlive: false,}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role', noCache: true,  affix: true}
      },
      {
        path: 'wldwscope',
        name: 'wldwscope',
        component: () => import('@/views/ums/wldwscope/index'),
        meta: {title: '经营范围'},
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '后台用户', noCache: true,  affix: true}
      },
      {
        path: 'editAdmin',
        name: 'editAdmin',
        component: () => import('@/views/ums/admin/editAdmin'),
        meta: {title: '修改用户', noCache: true,  affix: true}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单', noCache: true,  affix: true},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },

      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      // {
      //   path: 'wldwscopelist',
      //   name: 'wldwscopelist',
      //   component: () => import('@/views/user/wldwscope/list'),
      //   meta: {title: '经营范围'},
      //   hidden:true
      // },
    ]
  },
  {
    path:'/chart',
    component: Layout,
    redirect: '/chart/FinanceRecords',
    name: 'chart',
    alwaysShow: true,
    meta: {title: '报表', icon: 'fa fa-user-o'},
    children: [
      {
        path: 'list',
        name: 'chartlist',
        component: () => import('@/views/chart/list'),
        meta: {title: '报表'}
      },
      {
        path: 'achievements',
        name: 'achievements',
        component: () => import('@/views/chart/achievements'),
        meta: {title: '绩效'}
      },
      {
        path: 'FinanceRecords',
        name: 'FinanceRecords',
        component: () => import('@/views/chart/FinanceRecords'),
        meta: {title: '财务日报'}
      },
      {
        path: 'OrderSummary',
        name: 'OrderSummary',
        component: () => import('@/views/chart/OrderSummary'),
        meta: {title: '订单汇总'}
      },
      {
        path: 'SalesRecords',
        name: 'SalesRecords',
        component: () => import('@/views/chart/SalesRecords'),
        meta: {title: '单品销售记录'}
      },
      {
        path: 'salesDetail',
        name: 'salesDetail',
        component: () => import('@/views/chart/salesDetail'),
        meta: {title: '挂账销售记录'}
      },
      {
        path: 'SupplierRecords',
        name: 'SupplierRecords',
        component: () => import('@/views/chart/SupplierRecords'),
        meta: {title: '推广员日报'}
      },
      {
        path: 'MovingpinGoods',
        name: 'MovingpinGoods',
        component: () => import('@/views/chart/MovingpinGoods'),
        meta: {title: '动销商品'}
      },
      {
        path: 'todayLogin',
        name: 'todayLogin',
        component: () => import('@/views/chart/todayLogin'),
        meta: {title: '用户统计'},
        hidden: true
      },
      {
        path: 'todayLogins',
        name: 'todayLogins',
        component: () => import('@/views/chart/todayLogins'),
        meta: {title: '用户统计'},
        hidden: true
      },
      {
        path: 'todayLogins2',
        name: 'todayLogins2',
        component: () => import('@/views/chart/todayLogins2'),
        meta: {title: '用户统计'},
        hidden: true
      },
      {
        path: 'lostCustomers',
        name: 'lostCustomers',
        component: () => import('@/views/chart/lostCustomers'),
        meta: {title: '流失客户数'},
        hidden: true
      },
      {
        path: 'lostOrderList',
        name: 'lostOrderList',
        component: () => import('@/views/chart/lostOrderList'),
        meta: {title: '历史采购', noCache: true,  affix: true},
        hidden: true
      },
      {
        path: 'WechatReconciliation',
        name: 'WechatReconciliation',
        component: () => import('@/views/chart/wechat'),
        meta: {title: '微信对账'},
        hidden: true
      },
      {
        path: 'dcount',
        name: 'dcount',
        component: () => import('@/views/salesman/dcount'),
        meta: {title: '部门销售统计', noCache: true,  affix: true}
      },
      {
        path: 'templateOrder',
        name: 'templateOrder',
        component: () => import('@/views/chart/templateOrder'),
        meta: {title: '模板导出', noCache: true,  affix: true}
      },
    ]
  },
  {
    path:'/chats',
    component: Layout,
    redirect: '/chats/chatRecord',
    name: 'chats',
    alwaysShow: true,
    meta: {title: '聊天', icon: 'fa fa-comments-o'},
    children: [
      {
        path: 'chatslist',
        name: 'chatslist',
        component: () => import('@/views/chats/index'),
        meta: {title: '聊天列表'}
      },
      {
        path: 'chatRecord',
        name: 'chatRecord',
        component: () => import('@/views/chats/chatRecord'),
        meta: {title: '聊天记录', noCache: true,  affix: true}
      }
    ]
  },
  {
    path:'/supplier',
    component: Layout,
    redirect: '/supplier/supplierlist',
    name: 'supplier',
    alwaysShow: true,
    meta: {title: '供应商', icon: 'fa fa-user-o'},
    children: [
      {
        path: 'supplierlist',
        name: 'supplierlist',
        component: () => import('@/views/supplier/user/index'),
        meta: {title: '供应商列表'}
      },
      {
        path: 'mysupplier',
        name: 'mysupplier',
        component: () => import('@/views/supplier/user/list'),
        meta: {title: '我的信息'}
      },
      {
        path: 'scompany',
        name: 'scompany',
        component: () => import('@/views/supplier/company/index'),
        meta: {title: '往来单位'}
      },
      {
        path: 'mycompany',
        name: 'mycompany',
        component: () => import('@/views/supplier/company/mycompany'),
        meta: {title: '我的单位'}
      },
      {
        path: 'scertificate',
        name: 'scertificate',
        component: () => import('@/views/supplier/certificate/list'),
        meta: {title: '公司资质'},
        hidden: true
      },
      {
        path: 'mycertificate',
        name: 'mycertificate',
        component: () => import('@/views/supplier/certificate/mycertificate'),
        meta: {title: '我的资质'}
      },
      {
        path: 'billing',
        name: 'billing',
        component: () => import('@/views/supplier/billing/index'),
        meta: {title: '大厅开票'}
      },
    ]
  },
  {
    path: '/salesman',
    component: Layout,
    redirect: '/salesman/index',
    name: 'salesman',
    alwaysShow: true,
    meta: {title: '业务员管理', icon: 'fa-code-fork'},
    children: [
      {
        path: 'salesMan',
        name: 'salesMan',
        component: () => import('@/views/salesman/index'),
        meta: {title: '业务员管理'}
      },
      {
        path: 'salesTeam',
        name: 'salesTeam',
        component: () => import('@/views/salesman/team'),
        meta: {title: '团队管理'}
      },
      {
        path: 'teamList',
        name: 'teamList',
        component: () => import('@/views/salesman/teamList'),
        meta: {title: '团队业务员'}
      },
      {
        path: 'teamCommission',
        name: 'teamCommission',
        component: () => import('@/views/salesman/teamCommission'),
        meta: {title: '团队提成设置', noCache: true,  affix: true}
      },
      {
        path: 'salesCommission',
        name: 'salesCommission',
        component: () => import('@/views/salesman/salesCommission'),
        meta: {title: '提成设置', noCache: true,  affix: true}
      },
      {
        path: 'bindGoodsInfo',
        name: 'bindGoodsInfo',
        component: () => import('@/views/salesman/productList'),
        meta: {title: '业务员商品', noCache: true,  affix: true}
      },
      {
        path: 'bindUserInfo',
        name: 'bindUserInfo',
        component: () => import('@/views/salesman/userList'),
        meta: {title: '业务员客户'}
      },
      {
        path: 'salesManOrder',
        name: 'salesManOrder',
        component: () => import('@/views/salesman/orderList'),
        meta: {title: '业务员订单'}
      },
      {
        path: 'salesCount',
        name: 'salesCount',
        component: () => import('@/views/salesman/count'),
        meta: {title: '业务统计', noCache: true,  affix: true}
      },
      {
        path: 'salesCounts',
        name: 'salesCounts',
        component: () => import('@/views/salesman/counts'),
        meta: {title: '业务员统计', noCache: true,  affix: true}
      },
      {
        path: 'salesMoney',
        name: 'salesMoney',
        component: () => import('@/views/salesman/money'),
        meta: {title: '业务员账户', noCache: true,  affix: true}
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/salesman/withdrawal'),
        meta: {title: '业务提成', noCache: true,  affix: true}
      },
      {
        path: 'AuditWithdrawal',
        name: 'AuditWithdrawal',
        component: () => import('@/views/salesman/AuditWithdrawal'),
        meta: {title: '业务提现', noCache: true,  affix: true}
      },
      {
        path: 'bill',
        name: 'salesbill',
        component: () => import('@/views/salesman/bill/index'),
        meta: {title: '业务员线下开单', noCache: true,  affix: true}
      },
      {
        path: 'onlineBill',
        name: 'onlineBill',
        component: () => import('@/views/salesman/bill/index2'),
        meta: {title: '业务员线上开单', noCache: true,  affix: true}
      },
      {
        path: 'zyBill',
        name: 'zyBill',
        component: () => import('@/views/salesman/zyBill/index'),
        meta: {title: '第三方线下开单', noCache: true,  affix: true}
      },
      {
        path: 'goodsLendList',
        name: 'goodsLendList',
        component: () => import('@/views/salesman/goodsLendList'),
        meta: {title: '样品申请审核'}
      },
    ]
  },
  {
    path: '/record',
    component: Layout,
    redirect: '/record/recordlist',
    name: 'record',
    alwaysShow: true,
    meta: {title: '测试', icon: 'fa fa-bug'},
    children: [
      {
        path: 'recordlist',
        name: 'recordlist',
        component: () => import('@/views/record/test/index'),
        meta: {title: '测试报告'},
      },
    ]
  },
  {
    path: '/codematch',
    component: Layout,
    redirect: '/codematch/codeMatch',
    name: 'codematch',
    alwaysShow: true,
    meta: {title: '商品比价', icon: 'fa fa-puzzle-piece'},
    children: [
      {
        path: 'matchCode',
        name: 'matchCode',
        component: () => import('@/views/code/index'),
        meta: {title: '商品对码'}
      },
      {
        path: 's_spu',
        name: 's_spu',
        component: () => import('@/views/code/s_spu'),
        meta: {title: 's_spu'}
      },
      {
        path: 's_sku',
        name: 's_sku',
        component: () => import('@/views/code/s_sku'),
        meta: {title: 's_sku'}
      },
      {
        path: 'contrast',
        name: 'contrast',
        component: () => import('@/views/code/contrast'),
        meta: {title: '商品比价'}
      },
    ]
  },
  {
    path: '/theme',
    component: Layout,
    redirect: '/theme/index',
    name: 'theme',
    alwaysShow: true,
    meta: {title: '主题', icon: 'fa fa-bug'},
    children: [
      {
        path: 'themelist',
        name: 'themelist',
        component: () => import('@/views/theme/index'),
        meta: {title: '主题列表'},
      },
      {
        path: 'floorlist',
        name: 'floorlist',
        component: () => import('@/views/theme/floorlist'),
        meta: {title: '主题详情'},
      },
    ]
  }, 
  {
    path: '/workshop',
    component: Layout,
    redirect: '/workshop/productionShop/index',
    name: 'workshop',
    alwaysShow: true,
    meta: {title: '生产厂房', icon: 'fa fa-bug'},
    children: [
      {
        path: 'productionShop',
        name: 'productionShop',
        component: () => import('@/views/workshop/productionShop/index'),
        meta: {title: '生产车间'},
      },
      {
        path: 'equipment',
        name: 'equipment',
        component: () => import('@/views/workshop/equipment/index'),
        meta: {title: '生产设备'},
      },
      {
        path: 'profession',
        name: 'profession',
        component: () => import('@/views/workshop/profession/index'),
        meta: {title: '工种'},
      },
      {
        path: 'productLine',
        name: 'productLine',
        component: () => import('@/views/workshop/productLine/index'),
        meta: {title: '产品线'},
      },
      {
        path: 'productLineProcesses',
        name: 'productLineProcesses',
        component: () => import('@/views/workshop/productLineProcesses/index'),
        meta: {title: '产品线工序'},
      },
      {
        path: 'ofproduction',
        name: 'ofproduction',
        component: () => import('@/views/workshop/ofproduction/index'),
        meta: {title: '生产工序'},
      },
      {
        path: 'technology',
        name: 'technology',
        component: () => import('@/views/workshop/technology/index'),
        meta: {title: '工序工艺'},
      },{
        path: 'teamsAndGroups',
        name: 'teamsAndGroups',
        component: () => import('@/views/workshop/teamsAndGroups/index'),
        meta: {title: '班组'},
      },
      ,{
        path: 'productionPlan',
        name: 'productionPlan',
        component: () => import('@/views/workshop/productionPlan/index'),
        meta: {title: '生产计划'},
      },
      ,{
        path: 'productionScheduling',
        name: 'productionScheduling',
        component: () => import('@/views/workshop/productionScheduling/index'),
        meta: {title: '生产计划安排'},
      },
      ,{
        path: 'documentApproval',
        name: 'documentApproval',
        component: () => import('@/views/workshop/documentApproval/index'),
        meta: {title: '单据审批'},
      },
      ,{
        path: 'documentApprovalSet',
        name: 'documentApprovalSet',
        component: () => import('@/views/workshop/documentApprovalSet/index'),
        meta: {title: '单据审批设置'},
      },
      ,{
        path: 'material',
        name: 'material',
        component: () => import('@/views/workshop/material/index'),
        meta: {title: '物料'},
      },
      ,{
        path: 'bom',
        name: 'bom',
        component: () => import('@/views/workshop/bom/index'),
        meta: {title: 'bom'},
      },
    ]
  }, 
  //   {
  //   path: '/oa',
  //   component: Layout,
  //   redirect: '/oa/reimbursement/index',
  //   name: 'oa',
  //   alwaysShow: true,
  //   meta: {title: 'OA', icon: 'fa fa-bug'},
  //   children: [
  //     {
  //       path: 'reimbursement',
  //       name: 'reimbursement',
  //       component: () => import('@/views/oa/reimbursement/index'),
  //       meta: {title: '报销'},
  //     }
  //   ]
  // }, 
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js